export const COMPLEX_KIND_MDU = 'mdu';
export const COMPLEX_KIND_SETTLEMENT = 'settlement';

export function normalizeComplexKind(value) {
  const cleaned = String(value || '').trim().toLowerCase();
  if (cleaned === COMPLEX_KIND_SETTLEMENT) return COMPLEX_KIND_SETTLEMENT;
  return COMPLEX_KIND_MDU;
}

/** Tenant-level object kind (preferred). Falls back to complex.complex_kind. */
export function resolveObjectKind({ user, activeTenant, complex } = {}) {
  if (activeTenant?.object_kind) {
    return normalizeComplexKind(activeTenant.object_kind);
  }
  if (user?.object_kind) {
    return normalizeComplexKind(user.object_kind);
  }
  if (complex?.complex_kind) {
    return normalizeComplexKind(complex.complex_kind);
  }
  return COMPLEX_KIND_MDU;
}

export function isSettlementComplex(complexOrKind) {
  if (!complexOrKind) return false;
  if (typeof complexOrKind === 'string') {
    return normalizeComplexKind(complexOrKind) === COMPLEX_KIND_SETTLEMENT;
  }
  return normalizeComplexKind(complexOrKind.complex_kind || complexOrKind.object_kind) === COMPLEX_KIND_SETTLEMENT;
}

export function isSettlementTenant({ user, activeTenant } = {}) {
  return resolveObjectKind({ user, activeTenant }) === COMPLEX_KIND_SETTLEMENT;
}

export function complexKindLabel(complexOrKind) {
  return isSettlementComplex(complexOrKind) ? 'Посёлок' : 'ЖК';
}

/**
 * UI vocabulary for MDU vs settlement client.
 * Source of truth: $isSettlementTenant (or any boolean settlement flag).
 */
export function getObjectKindLabels(isSettlement = false) {
  if (isSettlement) {
    return {
      complex: 'Посёлок',
      complexPlural: 'Посёлки',
      complexListTab: 'Список посёлков',
      complexEmpty: 'Посёлков пока нет',
      addComplex: 'Добавить посёлок',
      addComplexShort: 'Добавить посёлок',
      selectComplex: 'Выбор посёлка',
      premises: 'Дома',
      premise: 'Дом',
      premiseNumber: 'Дом',
      apartment: 'Дом',
      apartmentShort: 'дом',
      house: 'Дом',
      houses: 'Дома',
      reportByComplex: 'Отчёт по посёлку',
      coverageComplex: 'Покрытие посёлка',
      complexWithDevices: 'Посёлки с устройствами',
      importComplexName: 'Посёлок Название',
      importComplexAddress: 'Посёлок Адрес',
      importApartmentHint: 'Для посёлка корпус оставьте пустым; «квартира» = номер участка. Без номера участка прибор уйдёт в «Сироты».',
      corpsSkipHint: 'Для посёлка корпуса не нужны. Можно сразу перейти к импорту: квартира = номер участка.',
    };
  }
  return {
    complex: 'ЖК',
    complexPlural: 'ЖК',
    complexListTab: 'Список ЖК',
    complexEmpty: 'ЖК пока нет',
    addComplex: 'Добавить ЖК',
    addComplexShort: 'Добавить комплекс',
    selectComplex: 'Выбор ЖК',
    premises: 'Помещения',
    premise: 'Помещение',
    premiseNumber: '№ помещения',
    apartment: 'Квартира',
    apartmentShort: 'кв.',
    house: 'Дом',
    houses: 'Дома',
    reportByComplex: 'Отчёт по ЖК',
    coverageComplex: 'Покрытие ЖК',
    complexWithDevices: 'ЖК с устройствами',
    importComplexName: 'ЖК Название',
    importComplexAddress: 'ЖК Адрес',
    importApartmentHint: 'Корпус можно не указывать, если дом без корпусов. Без номера квартиры прибор уйдёт в «Сироты».',
    corpsSkipHint: 'Корпуса нужны только если у одного адреса есть крылья (к1, к2). Если дом без корпусов — шаг можно пропустить.',
  };
}
